module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Alternative.19d4bd2d-ps.jpg";